export const SET_RESPONSE_MESSAGE = "SET_RESPONSE_MESSAGE";
export const SET_REPORTS_HISTORY_LOADER = "SET_REPORTS_HISTORY_LOADER";
const mutations = {
  [SET_RESPONSE_MESSAGE](state, payload) {
    state.responseMessage = payload;
  },
  [SET_REPORTS_HISTORY_LOADER](state, reportHistoryLoading) {
    state.reportsHistoryLoader = reportHistoryLoading;
  }
};
export default mutations;